<template>
  <div class="template basic-template scrollbar_basic">
    <header class="template__header">
      <Logo :app="owner_app" type="dark" size="medium" />
    </header>
    <section class="template__body">
      <slot name="body"></slot>
    </section>
    <footer class="template__footer">
      <template v-if="showSocialNetwork">
        <p class="body-1 mrg-bottom-8 footer__text">
          Copyright © {{ getOwnerCopyright() }}. Todos los derechos reservados.
        </p>
        <p class="body-1 mrg-bottom-12 footer__text">
          <a
            :href="vari.WEB_POLICY"
            target="_blank"
            rel="noopener noreferrer"
            class="footer__link"
            >Política de Seguridad y Privacidad</a
          >
        </p>
        <a
          href="https://www.linkedin.com/company/beexcc/"
          target="_blank"
          rel="noopener noreferrer"
          class="mrg-right-12 footer__link"
          ><a-icon type="linkedin" class="footer__icon"
        /></a>
        <a
          href="https://www.facebook.com/beexcc/"
          target="_blank"
          rel="noopener noreferrer"
          class="mrg-right-12 footer__link"
          ><a-icon type="facebook" class="footer__icon"
        /></a>
        <a
          href="https://www.instagram.com/beex_cc/"
          target="_blank"
          rel="noopener noreferrer"
          class="mrg-right-12 footer__link"
          ><a-icon type="instagram" class="footer__icon"
        /></a>
        <a
          href="https://www.youtube.com/@beexcc/"
          target="_blank"
          rel="noopener noreferrer"
          class="footer__link"
          ><a-icon type="youtube" class="footer__icon"
        /></a>
      </template>
      <p v-else class="body-1 mrg-bottom-0">
        Copyright © {{ getOwnerCopyright() }}. Todos los derechos reservados.
        Política de Seguridad y Privacidad
      </p>
    </footer>
    <!--Imagen de nube de inbox-->
    <div class="cloud">
      <img
        v-if="customBackground === 'valentine'"
        src="@/app/shared/assets/bg-valentine.svg"
        width="436"
        height="397"
        svg-online
      />
      <img
        v-else-if="customBackground === 'woman'"
        src="@/app/shared/assets/bg-woman.svg"
        svg-online
      />
      <img
        v-else-if="customBackground === 'earth-day'"
        src="@/app/shared/assets/bg-earth-day.svg"
        svg-online
        width="436"
        height="397"
      />
      <img
        v-else-if="customBackground === 'star-wars'"
        src="@/app/shared/assets/bg-star-wars.svg"
        width="436"
        height="397"
        svg-online
      />
      <img
        v-else-if="customBackground === 'pride-day'"
        src="@/app/shared/assets/bg-pride-day.svg"
        width="436"
        height="397"
        svg-online
      />
      <img
        v-else-if="customBackground === 'halloween'"
        src="@/app/shared/assets/bg-halloween.svg"
        width="436"
        height="397"
        svg-online
      />
      <img
        v-else-if="customBackground === 'christmas'"
        src="@/app/shared/assets/bg-christmas.svg"
        width="436"
        height="397"
        svg-online
      />
      <img
        v-else-if="customBackground === 'new-year'"
        src="@/app/shared/assets/bg-new-year.svg"
        width="436"
        height="397"
        svg-online
      />
      <svg
        v-else
        width="436"
        height="397"
        viewBox="0 0 436 397"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.2"
          d="M365.469 176.382L359.826 173.583L358.133 166.863C337.256 71.6728 255.44 0 167.981 0C99.142 0 35.9459 36.3963 0.398056 95.1904C12.2473 95.1904 23.5323 96.8702 34.2531 99.67L36.5101 96.8702C67.544 55.4344 116.634 30.7969 167.981 30.7969C257.132 30.7969 324.842 117.028 331.049 198.78C372.24 204.379 404.402 239.656 404.402 282.212C404.402 328.687 366.597 366.203 319.764 366.203H211.428C171.366 366.203 138.64 333.726 138.64 293.41C138.64 288.371 139.204 283.891 139.768 279.412C141.461 270.453 142.589 261.494 142.589 253.094C142.589 190.941 102.528 136.066 43.2812 116.468C43.2812 116.468 21.8396 108.069 -6.93721 109.189C-8.06572 109.189 -14.2725 109.749 -14.2725 109.749C-89.3179 115.908 -148 178.622 -148 253.094C-148 302.929 -122.609 348.285 -79.7256 375.162C-72.3903 379.642 -64.4908 383.561 -56.0271 386.921C-52.6416 388.601 -49.256 389.721 -46.4348 390.281L-44.742 390.841C-41.3565 391.961 -37.971 393.08 -34.0213 393.64C-30.0715 394.76 -25.5575 395.32 -21.0435 395.88C-14.8367 396.44 -8.62996 397 -2.4232 397H320.328C384.089 397 436 345.485 436 282.212C436 236.296 408.352 194.86 365.469 176.382ZM-2.98744 366.203C-65.6193 366.203 -116.402 315.808 -116.402 253.654C-116.402 223.417 -104.553 195.42 -83.1111 174.142C-80.2899 171.343 -69.5691 162.944 -66.7478 160.704L-65.0551 159.584C-62.7981 157.904 -60.5411 156.784 -57.7198 155.104C-57.1556 154.544 -56.0271 154.544 -54.8986 153.425C-52.6415 152.305 -50.3845 151.185 -48.1275 150.065C-46.999 149.505 -45.8705 148.945 -44.742 148.945C-42.485 147.825 -40.228 147.265 -37.971 146.705C-36.8425 146.145 -35.1498 146.145 -34.0213 145.585C-31.7643 145.025 -29.5073 144.465 -27.2503 143.906C-25.5575 143.346 -24.429 143.346 -22.7362 142.786C-20.4792 142.226 -18.2222 142.226 -15.9652 141.666C-14.2725 141.666 -13.144 141.106 -11.4512 141.106C-8.62994 141.106 -5.24446 140.546 -1.85895 140.546C60.7729 140.546 111.556 190.941 111.556 253.094C111.556 260.374 110.991 268.213 109.299 275.492C108.17 281.652 107.606 287.811 107.606 293.41C107.606 311.889 112.684 330.367 122.276 346.605L134.126 366.203H-2.98744Z"
          fill="#E9E9EA"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import Logo from '@/app/shared/components/logos/Logo'
import vari from '@/app/shared/utils/variables'
import transformMixin from '@/app/shared/mixins/transform'

export default {
  name: 'AuthTemplate',
  props: {
    showSocialNetwork: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    Logo,
  },
  mixins: [transformMixin],
  data: () => ({
    app: process.env.VUE_APP_NAME,
    owner_app: !process.env.VUE_APP_OWNER_APP
      ? process.env.VUE_APP_NAME
      : process.env.VUE_APP_OWNER_APP,
    customBackground: process.env.VUE_APP_NAME_CUSTOM,
    vari: vari,
  }),
}
</script>

<style lang="sass" scoped>
.template
  background-color: $white_000
  min-height: 100vh
  max-height: 100vh
  overflow: auto
  position: relative
  display: flex
  flex-direction: column
  &__header
    padding: 32px 0px
    border-bottom: 1px solid $gray_light_100
    display: flex
    align-items: center
    justify-content: center
    @include xs
      padding: 8px 0px
      border-bottom: none
      margin-bottom: 0px
    @include sm
      padding: 16px 0px
      border-bottom: none
      margin-bottom: 0px
    @include md
      padding: 16px 0px
      border-bottom: none
      margin-bottom: 0px
  &__body
    margin-top: 40px
    flex-grow: 1
    display: flex
    justify-content: center
    z-index: 2
    @include xs
      margin-top: 0px
      padding: 0px 20px
    @include sm
      margin-top: 0px
      padding: 0px 20px
    @include md
      margin-top: 0px
      padding: 0px 20px
  &__footer
    padding: 12px
    color: $gray_light_600
    width: 100%
    z-index: 2
.footer
  &__text
    color: inherit
  &__link
    color: inherit
    &:hover
      color: $gray_light_800
  &__icon
    color: $gray_light_500
    font-size: 24px
.cloud
  display: block
  position: fixed
  left: 0
  bottom: 0
  @include xs
    display: none
  @include sm
    display: none
  @include md
    display: none
</style>
